<template>
  <div
    v-if="messages && messages.length > 0"
    class="app-messages"
  >
    <v-row
      v-for="(message, index) in messages"
      :key="index + '-message'"
      no-gutters
    >
      <v-alert
        :type="message.type.toLowerCase()"
        closable
        class="mb-1"
      >
        {{ message.message }}
      </v-alert>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { useAppStore } from '@/stores/app'
import { useLayout } from 'vuetify'

export default defineComponent({
  setup() {
    const { mainRect } = useLayout()

    return {
      mainRect,
    }
  },
  computed: {
    ...mapState(useAppStore, ['messages']),
    topOffset(): string {
      return `${this.mainRect.top}px`
    },
  },
})
</script>

<style scoped lang="scss">
.app-messages {
  position: fixed;
  top: max(v-bind(topOffset), var(--v-safe-area-top));
  left: calc(100% / 2);
  transform: translate(-50%, 0);
  max-width: 600px;
  width: 100%;
  z-index: 99000;
}
</style>
